import { API } from "config";
import type { ChatThread } from "types/ChatThread";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

/**
 * Creates a new chat thread.
 */
export async function postThread(
  thread: ChatThread,
  getAccessToken: () => Promise<string>
) {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/threads`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = {
    method: "POST",
    headers,
    body: JSON.stringify(thread),
  };

  const response = await request(url, options);
  return (await response.json()) as ChatThread;
}
